import userpool from './userpool';

const getCognitoAccessToken = async () => {
  const cognitoUser = userpool.getCurrentUser();
  if (!cognitoUser) {
    return '';
  }

  try {
    const session = await new Promise((resolve, reject) => {
      cognitoUser.getSession((err, s) => {
        if (err) {
          reject(err);
        } else {
          resolve(s);
        }
      });
    });

    if (session.isValid()) {
      return session.accessToken.jwtToken;
    }
    const refreshedSession = await new Promise((resolve, reject) => {
      cognitoUser.refreshSession(session.refreshToken, (err, rs) => {
        if (err) {
          reject(err);
        } else {
          resolve(rs);
        }
      });
    });

      return refreshedSession.accessToken.jwtToken;
  } catch (error) {
    return '';
  }
};

export default getCognitoAccessToken;
